import React from "react";
import Button from "@mui/material/Button";
import { useFormContext } from "react-hook-form";

const FileUploadButton = ({ fieldName, label, handleImageFunc ,register, watch, clearErrors,errors}) => {
  return (
    <div className="d-flex justify-content-around mb-3 mt-2 gap-3">
      <Button
        variant="contained"
        component="label"
        {...register(fieldName)}
        onClick={() => clearErrors(fieldName)} // Clear errors when file input is clicked
      >
        {label}
        <input
          type="file"
          hidden
          {...register(fieldName)}
          onChange={(e) => handleImageFunc(fieldName, e)}
          className={`file_button mb-1 ${
            errors[fieldName]?.file ? "error" : ""
          }`}
        />
      </Button>

      {/* Image Preview */}
      {watch(fieldName) && (
        <div className="image_div">
          <img
            src={watch(fieldName)}
            alt="Preview"
            width={100}
            height="auto"
            className="rounded image bg-black"
          />
        </div>
      )}
    </div>
  );
};

export default FileUploadButton;
